/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useMemo as t}from"react";import{copyRawValuesOnly as r}from"../html/use-props.js";import{buildSVGAttrs as s}from"./utils/build-attrs.js";import{createSvgRenderState as e}from"./utils/create-render-state.js";import{isSVGTag as o}from"./utils/is-svg-tag.js";function l(l,i,m,a){const n=t((()=>{const t=e();return s(t,i,{enableHardwareAcceleration:!1},o(a),l.transformTemplate),{...t.attrs,style:{...t.style}}}),[i]);if(l.style){const t={};r(t,l.style,l),n.style={...t,...n.style}}return n}export{l as useSVGProps};
//# sourceMappingURL=use-props.js.map
